// icons
import IconCheck from '../../../../assets/icons/icon_check'

export function Checkbox(props: {value: boolean}) {
	return (
		<button className={`checkbox ${props.value ? 'checked' : ''}`} >
			{props.value ? <IconCheck /> : ''}
		</button> 
	);
}

